import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let board_id = useDataValue({
    viewPath: props.viewPath,
    context: 'event_action',
    path: 'data.board_id',
  })

  return {
    variables: {
      board_id,
    },
    pause: !board_id || board_id === 'new',
  }
}
